import { createReducer, on } from '@ngrx/store';
import * as fromAccountActions from '../actions/account.action';
export const featureKey = 'account';

export interface State {
    userProfile: any;
    applicantDetails: any;
    dashboardCounts: any;
    fromPage:any;
    rolesPermissions:{
		data: any,
		isLoaded: Boolean
	};
}

export const initialState: State = {
    userProfile: null,
    applicantDetails: null,
    dashboardCounts: null,
    fromPage: null,
    rolesPermissions: {
        data:null,
        isLoaded: false
    }
}

export const reducer = createReducer(
    initialState,
    on(fromAccountActions.getUserProfileSuccess, (state: State, props: any) => ({
        ...state,
        userProfile: props.data
    })),
    on(fromAccountActions.getApplicantDetailsSuccess, (state: State, props: any) => ({
        ...state,
        applicantDetails: props.data
    })),
    on(fromAccountActions.getDashboardCountsSuccess, (state: State, props: any) => ({
        ...state,
        dashboardCounts: props.data
    })),
    on(fromAccountActions.getFromPage, (state: State, props: any) => ({
        ...state,
        fromPage: props.data
    })),
    on(fromAccountActions.getRolesPermissionSuccess, (state: State, props: any) => ({
        ...state,
        rolesPermissions: {data : props.data, isLoaded: true}
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);